import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { primaryBlockDefaultStyles } from "../constants";

export interface HomepageBlock1Props extends ComponentPropsWithRef<"div"> {
  buttons?: ReactNode;
  leftContent?: ReactNode;
  rightContent?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HomepageBlock1 = forwardRef<HTMLDivElement, HomepageBlock1Props>(
  ({ leftContent, buttons, styles, rightContent, className, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: primaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background style={backgroundStyles}>
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <div className="wb-grid md:wb-grid-cols-2 md:wb-gap-12 wb-gap-4">
                <div className="wb-flex wb-flex-col wb-gap-3 md:wb-gap-5 wb-text-center md:wb-text-left place-content-center">
                  {leftContent}
                  <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-flex-wrap wb-gap-3 md:wb-flex-row md:wb-gap-3 wb-mt-2 md:wb-items-center">
                    {buttons}
                  </BlockSection.NestedBlock>
                </div>
                <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-flex-col wb-gap-4 wb-w-full">
                  {rightContent}
                </BlockSection.NestedBlock>
              </div>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

HomepageBlock1.displayName = "HomepageBlock1";
